var _path;

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a4 4 0 014-4h24c2.206 0 4 1.79 4 4v16c0 2.206-1.794 4-4 4H8c-2.21 0-4-1.794-4-4V12zm2 0v2.494l12.225 8.962a3 3 0 003.55 0L34 14.494V12c0-1.106-.894-2-2-2H7.944c-1.048 0-2 .894-2 2H6zm0 4.975V28c0 1.106.896 2 2 2h24c1.106 0 2-.894 2-2V16.975l-11.044 8.094a4.989 4.989 0 01-5.912 0L6 16.975z"
  })));
}

export default SvgMail;